export default __webpack_public_path__ + "static/media/project_card.c9c56c08.png";